import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface TransactionTypeDTO {
  id: string;
  transactionType: string;
  transactionDate: moment.Moment | null;
  transactionId: string;
  transactionReference: string;
  nameId: string;
  name: string;
  amount: number;
  //modified: moment.Moment | null;
}
const TransactionTypeDTO = {
  create: (initValues?: Partial<TransactionTypeDTO>): TransactionTypeDTO => {
    const defaults: TransactionTypeDTO = {
      id: '',
      transactionType: '',
      transactionDate: null,
      transactionId: '',
      transactionReference: '',
      nameId: '',
      name: '',
      amount: 0,
     // modified: null
    };
    const fixedInitValues: Partial<TransactionTypeDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
        transactionDate: ObjectUtil.ToMoment(initValues.transactionDate),
       // modified: ObjectUtil.ToMoment(initValues.modified),
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default TransactionTypeDTO;
